export default '$_recipe';
